module.exports = __webpack_public_path__ + "assets/retina_LDropPerp2Detailed.1c3c6ef3f0a0c1b6caa4fe491d8931be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_LDropPerp2Detailed.png
// module id = 684
// module chunks = 0